"use client";

import Link from "next/link";
import { getLocaleFromPathname, withLocale } from "@/lib/i18n";
import { usePathname } from "next/navigation";
import { getLayoutCopy } from "@/lib/layout-copy";

export function Footer() {
  const pathname = usePathname() || "/";
  const locale = getLocaleFromPathname(pathname);
  const copy = getLayoutCopy(locale).footer;

  return (
    <footer className="bg-positivus-dark text-white rounded-t-[45px] mt-12 md:mt-24">
      <div className="container mx-auto px-4 md:px-12 py-12">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-12">
          <div className="flex items-center gap-2">
            <img src="/logo.svg" alt="Dogufy" className="h-8 w-auto" />
            <span className="text-2xl font-semibold font-sans">dogufy.com</span>
          </div>
          
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
            <Link href={withLocale(locale, "/")} className="hover:underline">{copy.home}</Link>
            <Link href={withLocale(locale, "/tools")} className="hover:underline">{copy.allTools}</Link>
            <Link href={withLocale(locale, "/blog")} className="hover:underline">{copy.blog}</Link>
            <Link href={withLocale(locale, "/about")} className="hover:underline">{copy.about}</Link>
            <Link href={withLocale(locale, "/how-dogufy-works")} className="hover:underline">{copy.howItWorks}</Link>
            <Link href={withLocale(locale, "/editorial-policy")} className="hover:underline">{copy.editorialPolicy}</Link>
            <Link href={withLocale(locale, "/contact")} className="hover:underline">{copy.contact}</Link>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center gap-8 mb-12">
          <div className="bg-positivus-green text-black px-4 py-1 rounded-md text-sm font-medium">{copy.contactUs}</div>
          <div className="text-center md:text-left">
            <a href="mailto:support@dogufy.com" className="hover:text-white">
              {copy.email}: support@dogufy.com
            </a>
          </div>

          <a
            href="https://github.com/Andikaa03/exodact"
            target="_blank"
            rel="noreferrer"
            className="rounded-[14px] border border-white/20 px-6 py-3 text-sm font-medium text-white transition-colors hover:border-positivus-green hover:bg-white hover:text-black"
          >
            {copy.sourceCode}
          </a>
        </div>
        
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center gap-8 text-sm text-gray-400">
           <p>{copy.copyright}</p>
           <Link href={withLocale(locale, "/privacy")} className="hover:text-white">{copy.privacy}</Link>
           <Link href={withLocale(locale, "/terms")} className="hover:text-white">{copy.terms}</Link>
           <Link href={withLocale(locale, "/html-sitemap")} className="hover:text-white">{copy.sitemap}</Link>
        </div>
      </div>
    </footer>
  );
}
